const routes = [
    {
        path: "/car/reservations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'carreservation_index'
        }
    }
];

export default routes;
